import { useRef, useEffect } from 'react';
import { Notification } from '@/hooks/useNotifications';
import NotificationItem from './NotificationItem';

interface NotificationDropdownProps {
    notifications: Notification[];
    onRead: (id: string) => void;
    onReadAll: () => void;
    onClose: () => void;
    isOpen: boolean;
}

export default function NotificationDropdown({ notifications, onRead, onReadAll, onClose, isOpen }: NotificationDropdownProps) {
    const dropdownRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                onClose();
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return (
        <div
            ref={dropdownRef}
            className="absolute right-0 mt-2 w-80 bg-white rounded-md shadow-lg overflow-hidden z-50 border border-gray-200 text-gray-800"
        >
            <div className="p-3 border-b flex justify-between items-center bg-gray-50">
                <h3 className="text-sm font-semibold text-gray-700">通知中心</h3>
                {notifications.length > 0 && (
                    <button
                        onClick={onReadAll}
                        className="text-xs text-blue-600 hover:text-blue-800"
                    >
                        全部已讀
                    </button>
                )}
            </div>

            <div className="max-h-96 overflow-y-auto">
                {notifications.length === 0 ? (
                    <div className="p-4 text-center text-gray-500 text-sm">
                        目前沒有新通知
                    </div>
                ) : (
                    notifications.map(notification => (
                        <NotificationItem
                            key={notification.id}
                            notification={notification}
                            onRead={onRead}
                        />
                    ))
                )}
            </div>

            <div className="p-2 border-t bg-gray-50 text-center">
                <a href="/notifications" className="text-xs text-gray-500 hover:text-gray-700 block py-1">
                    查看所有通知
                </a>
            </div>
        </div>
    );
}
